
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 37.87V21.23c0-10.55 8.28-19.1 18.5-19.1s18.5 8.55 18.5 19.1v16.64","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M32.82 29.17l-.03 7.66H7.18v-7.66h25.64zM16.29 16.26V11.5h7.42v4.81M31.45 16.61l-3.92 5.66H12.37l-3.83-5.56M16.29 21.62v7.63M23.71 21.62v7.63M2.74 16.65h34.52"}})])
          )
        }
      }
    